import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollMagic from 'scrollmagic';

export default () => {
    gsap.registerPlugin(ScrollTrigger);
    const scrollMagContr = new ScrollMagic.Controller();

    // animation for text and images in large sections
    const fadeInElems = document.querySelectorAll('[data-fade-in-elem]');
    if (fadeInElems.length > 0) {
        fadeInElems.forEach((elem, i) => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem.closest('[data-fade-in-container]'),
                    start: 'top 85%',
                },
                y: 0,
                opacity: 1,
                delay: elem.getAttribute('data-anim-delay'), // delay between elemens have to be 0.2s
                duration: 1.2,
                ease: 'power3.out'
            })
        });
    }

    // animation for menus, forms and other small horizontal sections
    // animation for background images
    const showUpElems = document.querySelectorAll('[data-show-up-elem]');
    if (showUpElems.length > 0) {
        showUpElems.forEach((elem, i) => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem.closest('[data-show-up-container]'),
                    start: 'top 95%',
                },
                opacity: 1,
                delay: elem.getAttribute('data-anim-delay'), // delay between elemens have to be 0.15s if it is small horizontal section
                duration: 1.2,
                ease: 'power3.out'
            })
        });
    }

    // zoom in animation for images
    const zoomInElems = document.querySelectorAll('[data-zoom-in-elem]');
    if (zoomInElems.length > 0) {
        zoomInElems.forEach((elem, i) => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem.closest('[data-zoom-in-container]'),
                    start: 'top 85%',
                },
                scale: 1,
                delay: elem.getAttribute('data-anim-delay'), // delay nested from previous animation
                duration: 1.2,
                ease: 'power3.out'
            })
        });
    }

    // change background color animation
    const customBgColor = document.querySelectorAll('[data-custom-bg-color]');
    const globalBg = document.querySelector('[data-global-bg]') || document.querySelector('.container') || document.querySelector('body');
    if (customBgColor.length > 0) {
        const defaultBgColor = getComputedStyle(globalBg).backgroundColor;
        customBgColor.forEach((elem, i) => {
            if (elem.getAttribute('data-custom-bg-color')) {
                const scene = new ScrollMagic.Scene({
                    triggerElement: elem,
                    triggerHook: 0.7,
                })
                .on('start', (e) => {
                    if (e.scrollDirection == 'FORWARD') {
                        gsap.to(globalBg, {
                            backgroundColor: elem.getAttribute('data-custom-bg-color') || defaultBgColor,
                            duration: 3,
                            ease: 'power1.out'
                        })
                    } else {
                        gsap.to(globalBg, {

                            backgroundColor: elem.previousElementSibling.getAttribute('data-custom-bg-color') || defaultBgColor,
                            duration: 3,
                            ease: 'power1.out'
                        })
                    }
                })
                .addTo(scrollMagContr)
            }
        });
    }

    // leaves shadows scroll parallax
    const parallaxShadows = document.querySelectorAll('[data-parallax-shadows]');
    if (parallaxShadows.length > 0) {
        let prevScroll = 0;

        const setShadowsPostion = (elem) => {
            const parallaxAmount = elem.getAttribute('data-parallax-shadows');
            const currentScroll = window.pageYOffset;
            const pageX = currentScroll + elem.parentElement.getBoundingClientRect().top;
            elem.style.transform = `translateY(${(currentScroll - pageX) * parallaxAmount}px)`;
            prevScroll = currentScroll;
        }

        parallaxShadows.forEach((elem, i) => {
            setShadowsPostion(elem)
            window.addEventListener('scroll', () => {
                setShadowsPostion(elem)
            })
        });
    }
}
